import React from 'react';
import './style/AboutUs.css';

const AboutUs = () => {
  return (
    <section className="experts-section d-flex align-items-center text-white">
      <div className="container">
        <div className="row align-items-center">
          {/* Image Section - Show First on Mobile */}
          <div
            className="col-md-6 text-center order-1 order-md-2"
            data-aos="zoom-in"
          >
            <div className="video-thumbnail">
              <img
                src="/assets/ShalishaHome.jpg"
                alt="Expert Working"
                className="img-fluid"
              />
            </div>
          </div>

          {/* Text Section - Show Second on Mobile */}
          <div
            className="col-md-6 order-2 order-md-1"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <p className="section-label">OUR EXPERTS</p>
            <h1 className="section-title">
              Shalisha Enterprise<br />Empowering Ideas. Delivering Excellence
            </h1>
            <p className="section-description">
              At Shalisha Enterprise, we are dedicated to delivering quality,
              reliability, and innovation in every product and service we
              offer. Our journey is built on trust, customer satisfaction, and a
              deep understanding of our clients’ needs. With a focus on
              excellence and a passion for perfection, we aim to create
              meaningful solutions that empower both businesses and individuals.
            </p>
            <a href="/contact" className="btn btn-warning book-btn">
              Book Service
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
